// extracted by mini-css-extract-plugin
module.exports = {"removeButton":"RemoveAction_removeButton__B46Vs"};